import client from './client';

/**
 * Auth API
 *
 * All endpoints map to /api/auth on the Spring Boot backend.
 *
 * AuthResponse shape:
 *   { accessToken, refreshToken, tokenType, expiresIn,
 *     user: { id, email, fullName, avatarUrl, role, emailVerified } }
 */

/** Register a new user. data: { fullName, email, password, role } */
export const register = (data) => {
  console.log('[auth] register', data?.email, 'role:', data?.role);
  return client.post('/api/auth/register', data);
};

/** Sign in with email + password. data: { email, password } */
export const loginPassword = (data) => {
  console.log('[auth] loginPassword', data?.email);
  return client.post('/api/auth/login', data);
};

/** Send an OTP code to the user's email. data: { email } */
export const sendOtp = (data) => {
  console.log('[auth] sendOtp', data?.email);
  return client.post('/api/auth/otp/send', data);
};

/** Verify an OTP code. data: { email, code } */
export const verifyOtp = (data) => {
  console.log('[auth] verifyOtp', data?.email);
  return client.post('/api/auth/otp/verify', data);
};

/** Exchange a refresh token for a new access/refresh pair. data: { refreshToken } */
export const refreshTokens = (data) => {
  console.log('[auth] refreshTokens');
  return client.post('/api/auth/refresh', data);
};

/** Invalidate the refresh token server-side. data: { refreshToken } */
export const logout = (data) => {
  console.log('[auth] logout');
  return client.post('/api/auth/logout', data);
};

/** Fetch the current authenticated user. */
export const getMe = () => {
  console.log('[auth] getMe');
  return client.get('/api/auth/me');
};

/**
 * Patch the authenticated user's profile (full name, avatar URL).
 * data: { fullName?, avatarUrl? } - omit a field to leave it unchanged.
 */
export const updateProfile = (data) => {
  console.log('[auth] updateProfile', Object.keys(data || {}));
  return client.patch('/api/users/me', data);
};

/**
 * Change the authenticated user's password.
 * data: { currentPassword, newPassword }
 */
export const changePassword = (data) => {
  console.log('[auth] changePassword');
  return client.post('/api/users/me/password', data);
};
